import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Lock, ArrowRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAdminAuth } from "@/lib/adminAuth";
import AdminDashboard from "@/components/admin/AdminDashboard";

const AdminPage = () => {
  const { authed, checking, login, logout } = useAdminAuth();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    setSubmitting(true);
    try {
      await login(password.trim());
      toast.success("Welcome, admin!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    }
    setSubmitting(false);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-14 h-14 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!authed) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-100 via-pink-50 to-blue-100 flex items-center justify-center px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white border-2 border-foreground rounded-3xl shadow-brutal p-8 max-w-md w-full"
        >
          <div className="text-center mb-6">
            <Lock size={48} className="text-foreground mx-auto mb-3" />
            <h1 className="font-fredoka font-bold text-2xl text-foreground">Admin Console</h1>
            <p className="font-nunito text-muted-foreground text-sm mt-1">
              Embrace the Magic of Words — content management
            </p>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <Input
              type="password"
              placeholder="Admin password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              className="font-nunito border-2 border-foreground rounded-xl py-5"
              data-testid="admin-password-input"
            />
            <Button
              type="submit"
              disabled={submitting}
              className="w-full bg-foreground hover:bg-foreground/90 text-white font-nunito font-bold border-2 border-foreground shadow-brutal active-brutal rounded-xl py-5"
              data-testid="admin-login-btn"
            >
              {submitting ? "Signing in..." : "Sign In"}
              <ArrowRight size={20} weight="bold" className="ml-2" />
            </Button>
          </form>
        </motion.div>
      </div>
    );
  }

  return <AdminDashboard onLogout={logout} />;
};

export default AdminPage;
